import { useRef, useState } from 'react';

interface GameCarouselProps {
  images: { src: string; alt: string }[];
}

export default function GameCarousel({ images }: GameCarouselProps) {
  const trackRef = useRef<HTMLDivElement>(null);
  const [current, setCurrent] = useState(0);
  const visible = 4;

  const prev = () => setCurrent((c) => Math.max(0, c - 1));
  const next = () => setCurrent((c) => Math.min(images.length - visible, c + 1));

  return (
    <div className="relative">
      <div className="overflow-hidden rounded-xl">
        <div
          ref={trackRef}
          className="flex gap-3 transition-transform duration-500"
          style={{ transform: `translateX(-${current * (100 / visible)}%)` }}
        >
          {images.map((img, i) => (
            <div
              key={i}
              className="flex-shrink-0 rounded-lg overflow-hidden cursor-pointer hover:scale-105 transition-transform duration-300"
              style={{ width: `calc(${100 / visible}% - 9px)` }}
            >
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover aspect-square" />
            </div>
          ))}
        </div>
      </div>
      <button
        onClick={prev}
        disabled={current === 0}
        className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-8 h-8 flex items-center justify-center bg-[#B80E28] rounded-full text-white text-xs disabled:opacity-30 cursor-pointer hover:bg-[#9a0b21] transition-colors"
      >
        <i className="fas fa-chevron-left"></i>
      </button>
      <button
        onClick={next}
        disabled={current >= images.length - visible}
        className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-8 h-8 flex items-center justify-center bg-[#B80E28] rounded-full text-white text-xs disabled:opacity-30 cursor-pointer hover:bg-[#9a0b21] transition-colors"
      >
        <i className="fas fa-chevron-right"></i>
      </button>
    </div>
  );
}
